import styled from 'styled-components';
import breakpoints from '../../breakpoints';
import { Link as LinkRouter } from '@reach/router'; 

const trackingToLetterSpacing = (spacing) => `${spacing/1000}em`;

export const LanguageSection = styled.div`
  background-color: #f8f8f8;
  display: flex;
  justify-content: flex-start;
  text-align: center;
  align-items: center;
  padding: 4px 0;
  margin: 0;
  width: 100%;
`

export const LanguageButton = styled.button`
  margin: 0 15px;
  border: none;
  background: none;
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  font-size: 14px;
  line-height: 1.30;
  &.active {
    font-family: 'ToyotaType Bold';
  }
`
export const Separator = styled.span`
  font-size: 21px;
`

export const PortfoliosButton = styled.div`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  font-size: 16px;
  display: flex;
  align-items: center;
  text-decoration: none;
  letter-spacing: ${trackingToLetterSpacing(50)};
  color: inherit;
  line-height: 20px;
  height: 60px;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  width: 100%;
  padding-left: 10px;
  ${breakpoints('tablet', 'up')} {
    font-size: 16px;
    line-height: 24px; 
  }
  background-color: #FFFFFF;
  &:hover {
    text-decoration: underline;
    background-color: #F1F1F1;
  }
`

export const Subcategories = styled.nav`
  display: ${({open}) => open ? 'flex' : 'none'};
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 61px;
  width: 100%;
  text-align: center;
`
export const MobileSubNav = styled.div`
  display: ${({open}) => open ? 'inline-block' : 'none'};
  position: absolute;
  left: 0;
  top: 45px;
  width: 100%;
  text-align: center;
`

export const Category = styled(LinkRouter)`
  color: inherit;
  text-decoration: none;
  line-height: 21px;
  height: 22px;
  width: 100%;
  background-color: #F1F1F1;
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  padding: 15px 15px 15px 25px;
  text-align: left;
  & > div {
    padding-bottom: 15px;
    border-bottom: 1px solid #ccc;
    width: 86%;
  }
  & > div > span {
    padding: 10px;
  }
  &:last-child > div {
    border-bottom: none;
  }
` 

export const ExpandSectionIcon = styled.img`
  transform: ${({isOpen}) => isOpen ? 'rotateX(180deg)' : ''};
  transition: transform .3s ease-in-out;
`
export const Languages = styled.div`
  display:flex;
  justify-content: flex-start;
  width: 100%;
`
export const AboutUs = styled(LinkRouter)`
  border: 1px solid #ccc;
  text-decoration: none;
  background-color: white;
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  margin-top: 258px;
  height: 42px;
  text-align: left;
  padding: 10px 10px 10px 20px;
  display: flex;
  justify-content: left;
  text-align: center;
  align-items: center;
  & > span {
    color: black;
    text-decoration: none;
  
  }
`
export const ButtonWrapper = styled.div`
  background-color: #FFFFFF;
  padding: 35px 0;
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  text-decoration: none;
  letter-spacing: ${trackingToLetterSpacing(50)};
  color: inherit;
  font-size: 16px;
  line-height: 1.2px;
`